import { Header } from './Header'
import { Hero } from './Hero'
import { HowItWorks } from './HowItWorks'
import { WhoItsFor } from './WhoItsFor'
import { SeeItInAction } from './SeeItInAction'
import { StylistIntelligence } from './StylistIntelligence'
import { WhyMichela } from './WhyMichela'
import { FAQ } from './FAQ'
import { WaitlistForm } from './WaitlistForm'
import { Footer } from './Footer'

export function MichelaLanding() {
    return (
        <div className="min-h-screen bg-paper text-ink">
            <Header />
            <main>
                <Hero />
                <HowItWorks />
                <WhoItsFor />
                <SeeItInAction />
                <StylistIntelligence />
                <WhyMichela />
                <FAQ />
                <section id="waitlist" className="py-24 sm:py-32">
                    <div className="max-w-2xl mx-auto px-8 sm:px-6 text-center">
                        {/* Section Header - matching other sections */}
                        <div className="mb-16 sm:mb-24">
                            <h2 className="font-display text-4xl sm:text-5xl font-semibold text-ink mb-6">
                                Dress better with the clothes you already own.
                            </h2>
                            <p className="text-ink-tertiary text-lg sm:text-xl leading-relaxed px-6 sm:px-0">
                                Get early access to Michela — a personal stylist that builds outfits around your plans, your weather, and your wardrobe.
                            </p>
                        </div>
                        <WaitlistForm />
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    )
}

export default MichelaLanding
